<template>
  <router-link v-bind="$attrs" :to="toModified">
    <template v-for="(_, slot) of $slots" #[slot]="scope"><slot :name="slot" v-bind="scope" /></template>
  </router-link>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const props = defineProps({
  to: {
    type: [String, Object],
    required: true,
  },
})

const toModified = computed(() => {
  if (typeof props.to === 'string') {
    const instance = getCurrentInstance()
    console.error(
      'Old type of path for router-link, change it.',
      props.to,
      'Parent component:',
      instance.parent.type.name
    )
    return props.to
  }

  const localeFromRoute = route?.params?.locale
  const toPath = { ...props.to, params: { ...(props.to?.params ?? {}) } }
  if (localeFromRoute) {
    if (toPath.params) {
      toPath.params.locale = localeFromRoute
    } else {
      toPath.params = { locale: localeFromRoute }
    }
  }
  return toPath
})
</script>
